<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
  <div class="textbook-category-select">
    <el-form
      :inline="true"
      class="select-unit"
      label-width="80px"
    >
      <el-form-item label="教材分类">
        <el-cascader
          ref="textbookCategorySelect"
          v-model="textbookCategory"
          style="min-width: 420px"
          :props="seriesSelectionProps"
          :options="series"
          @change="selectLevels"
        />
      </el-form-item>

      <el-form-item
        v-if="versionShow"
        label="教材版本"
      >
        <el-select
          v-model="selectVersion"
          filterable
          clearable
          @change="change"
        >
          <el-option
            v-for="item in textbookVersions"
            :key="item.version"
            :label="item.name"
            :value="item.version"
          />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const debug = require('debug')('ccs:component:textbook-category-select');
import {
	getTextbookSeries,
	getTextbookCategoryTree
} from '../service/textbook';
import { TEXTBOOK_VERSIONS } from '../constants';
import { isNil, find } from 'lodash';
import axios from 'axios';

export default {
	props: {
		courseTypeCode: [Number, String],
		categoryCode: [Number, String],
		version: [Number, String],
		versionShow: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			// 级联配置
			seriesSelectionProps: {
				value: 'code',
				label: 'name',
				expandTrigger: 'hover'
			},
			textbookCategory: [],
			series: [],
			levels: [],
			textbookVersions: TEXTBOOK_VERSIONS,
			selectVersion: null
		};
	},
	async created() {
		await this.init();
	},
	methods: {
		async init() {
			debug(
				'[init] courseTypeCode: %s, categoryCode: %s, version: %s',
				this.courseTypeCode,
				this.categoryCode,
				this.version
			);
			const series = await getTextbookCategoryTree();
			this.series = series;

			if (this.courseTypeCode && this.categoryCode) {
				this.textbookCategory = [this.courseTypeCode, this.categoryCode];
			}

			if (
				!isNil(this.version) &&
        '' !== this.version &&
        parseInt(this.version) >= 0
			) {
				this.selectVersion = parseInt(this.version);
			}

			await this.selectLevels();
		},

		async selectLevels() {
			const [courseTypeCode, categoryCode] = this.textbookCategory;
			if (courseTypeCode || categoryCode) {
				const levels = await getTextbookSeries({ courseTypeCode, categoryCode });
				this.levels = levels;
			} else {
				this.levels = [];
			}

			this.change();
		},

		change() {
			debug(
				'[change] version: %s, levels: %o',
				this.selectVersion,
				this.levels
			);
			let levels = this.levels;
			if (!isNil(this.selectVersion) && '' !== this.selectVersion) {
				levels = this.levels.filter(
					level => level.version === this.selectVersion
				);
			}
			debug('levels: %o', levels);
			this.$emit('change', levels);
		}
	}
};
</script>
